import {Location} from '@angular/common';
import {Component, EventEmitter, Input, Output} from '@angular/core';
import {Router} from '@angular/router';
import {AppointmentRequestRequirements} from '@shared/models/appointment-request.model';
import {AppointmentService} from '@shared/services/appointment.service';

@Component({
  selector: 'si-appo-no-available-dates-dialog',
  templateUrl: './appo-no-available-dates-dialog.component.html',
  styleUrls: ['./appo-no-available-dates-dialog.component.scss']
})
export class AppoNoAvailableDatesDialogComponent {
  @Input() displayDialog: boolean;
  @Input() dialogText: string;
  @Input() showAppoRequestBackButton = true;
  @Input() showRequestAppointmentButton: boolean;
  @Input() model: AppointmentRequestRequirements;
  @Output() updateChange = new EventEmitter<boolean>();
  @Output() displayDialogChange = new EventEmitter<boolean>();

  constructor(
    private location: Location,
    private appointmentService: AppointmentService,
    private router: Router
  ) {
  }

  onVisibleChange(value: boolean): void {
    if (!value) {
      this.onClickCloseDialog(true);
    }
  }

  onClickButtonRegisterRequest(): void {
    this.appointmentService.setAppointmentRequestRequirementsModel(this.model);
    this.router.navigate(['/request/appointment']);
  }

  onClickCloseDialog(action: boolean): void {
    if (action) {
      this.updateChange.emit();
    } else {
      this.location.back();
    }

    this.displayDialog = false;
    this.displayDialogChange.emit(this.displayDialog);
  }
}
